<template>
	<div>
		<!-- import header -->
		<app-header/>

		<!-- display pages -->
		<slot/>

		<!-- import footer -->
		<app-footer/>
	</div>
</template>

<script>
import Header from '@/components/general/shared/Header.vue'
import Footer from '@/components/general/shared/Footer.vue'

export default {
	name: "User",
	components: {
		appHeader: Header,
		appFooter: Footer
	}
}
</script>
